import { useTranslation } from 'react-i18next';
import { Bell } from 'lucide-react';
import { GuideSection } from '../components/GuideSection';
import { GuideSubSection } from '../components/GuideSubSection';

export function NotificationsSection() {
  const { t } = useTranslation('help');
  const s = 'sections.notifications';

  return (
    <GuideSection
      id="notifications"
      title={t(`${s}.title`)}
      description={t(`${s}.description`)}
      icon={Bell}
    >
      <GuideSubSection title={t(`${s}.inApp.title`)}>
        <p>{t(`${s}.inApp.p1`)}</p>
        <p>{t(`${s}.inApp.p2`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.email.title`)}>
        <p>{t(`${s}.email.p1`)}</p>
        <p>{t(`${s}.email.p2`)}</p>
        <p>{t(`${s}.email.p3`)}</p>
      </GuideSubSection>

      <GuideSubSection title={t(`${s}.control.title`)}>
        <p>{t(`${s}.control.p1`)}</p>
        <p>{t(`${s}.control.p2`)}</p>
      </GuideSubSection>
    </GuideSection>
  );
}
